var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtDonut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 427,
    viewBox: "0 0 553 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 471.251,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3901,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3901,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3901,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3901,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 516.078,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 516.078,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 516.078,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 516.078,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 460.907,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 442.517,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 423.552,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 405.162,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 18.3903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7808,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9517,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 73.561,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 128.732,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 256.89,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 256.89,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 312.061,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 312.061,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 110.342,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 129.307,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 110.917,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 166.087,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 184.478,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 202.868,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 147.697,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 165.513,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 147.123,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 312.061,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 294.245,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 348.841,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 348.841,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 348.841,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 348.841,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 348.841,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 373.553,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 373.553,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 373.553,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 366.657,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 366.657,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 386.196,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 379.3,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 397.69,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 397.69,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 397.69,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 397.69,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 397.69,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 257.464,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 404.587,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 422.977,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 239.074,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 497.688,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 119.537,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 137.927,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 119.537,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 137.927,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 460.907,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 460.907,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 460.907,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 151.72,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 170.11,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 151.72,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 170.11,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 467.229,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 467.229,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 188.501,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 151.72,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 448.264,
    y: 170.11,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 151.72,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 466.654,
    y: 170.11,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 432.172,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 432.172,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#FF00D2"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 432.172,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 432.747,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 432.172,
    y: 233.902,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 479.297,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 119.537,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 137.927,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 464.355,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 464.355,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 464.355,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 464.355,
    y: 135.629,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 435.621,
    y: 149.421,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 119.537,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 137.927,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 82.7564,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 101.147,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 82.7564,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 101.147,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 82.7564,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 101.147,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 416.081,
    y: 64.3661,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 434.471,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 452.861,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 275.855,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1709,
    y: 220.684,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 36.7806,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 55.1709,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 73.5612,
    width: 18.3903,
    height: 18.3903,
    fill: "#CCD2F0"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 91.9515,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#A7B2EE"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 312.635,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5962,
    y: 335.048,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 478.723,
    y: 335.048,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2061,
    y: 298.268,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2061,
    y: 316.658,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8154,
    y: 261.487,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8154,
    y: 279.878,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 497.113,
    y: 298.268,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 497.113,
    y: 316.658,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 515.503,
    y: 261.487,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 515.503,
    y: 279.878,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 533.894,
    y: 224.707,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 533.894,
    y: 243.097,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 533.894,
    y: 187.926,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 533.894,
    y: 206.316,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 533.894,
    y: 169.536,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    y: 224.707,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    y: 243.097,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    y: 187.926,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    y: 206.316,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    y: 169.536,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 91.377,
    y: 353.439,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9863,
    y: 353.439,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 460.333,
    y: 353.439,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 441.942,
    y: 353.439,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 423.552,
    y: 371.829,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 405.162,
    y: 371.829,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 128.157,
    y: 371.829,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 109.767,
    y: 371.829,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 164.938,
    y: 390.219,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 146.548,
    y: 390.219,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 183.329,
    y: 390.219,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 367.231,
    y: 390.219,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 348.841,
    y: 390.219,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 385.622,
    y: 390.219,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 256.89,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 312.061,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 330.451,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 202.293,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 220.684,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 239.074,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 257.464,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 275.854,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 294.245,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 312.635,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 408.61,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 256.89,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 220.109,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 201.719,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 183.903,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 147.122,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 367.806,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 128.732,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 331.025,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 349.416,
    y: 183.903,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 312.061,
    y: 110.342,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 256.89,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 312.061,
    y: 202.293,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 239.649,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 258.039,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 276.429,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 313.21,
    y: 165.513,
    width: 18.3903,
    height: 18.3903,
    fill: "#071785"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtDonut);
export default __webpack_public_path__ + "static/media/pixel-art-donut.3be27f3866bddb5dff4d920648488b28.svg";
export { ForwardRef as ReactComponent };